/**
 * NO04 - Ordre Search Saga Index
 */

import { takeLatest, takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../actions/actionTypesNO04';
import * as sagas from './NO04.saga';

export function* watchNO04() {
  yield takeLatest(actionTypes.NO04_SEARCH_REQUEST, sagas.searchNO04OrdersSaga);
  yield takeEvery(actionTypes.NO04_LOAD_MORE_REQUEST, sagas.loadMoreNO04OrdersSaga);
  yield takeLatest(actionTypes.NO04_ORDER_DETAIL_REQUEST, sagas.fetchNO04OrderDetailSaga);
}
